'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesActionsAddChild: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.addChild'
        },
        messagesActionsAppend: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.append'
        },
        messagesActionsInsertAfter: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.insertAfter'
        },
        messagesActionsInsertBefore: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.insertBefore'
        },
        messagesActionsPdf: {
            type: String,
            default: undefined,
            kComposite: 'messages.actions.pdf'
        },
        messagesCancel: {
            type: String,
            default: undefined,
            kComposite: 'messages.cancel'
        },
        messagesDeleteDependencyConfirmation: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteDependencyConfirmation'
        },
        messagesDeleteDependencyWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteDependencyWindowTitle'
        },
        messagesDeleteTaskConfirmation: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteTaskConfirmation'
        },
        messagesDeleteTaskWindowTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.deleteTaskWindowTitle'
        },
        messagesDestroy: {
            type: String,
            default: undefined,
            kComposite: 'messages.destroy'
        },
        messagesEditorAssignButton: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.assignButton'
        },
        messagesEditorEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.editorTitle'
        },
        messagesEditorEnd: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.end'
        },
        messagesEditorPercentComplete: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.percentComplete'
        },
        messagesEditorResources: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.resources'
        },
        messagesEditorResourcesEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.resourcesEditorTitle'
        },
        messagesEditorResourcesHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.resourcesHeader'
        },
        messagesEditorStart: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.start'
        },
        messagesEditorTitle: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.title'
        },
        messagesEditorUnitsHeader: {
            type: String,
            default: undefined,
            kComposite: 'messages.editor.unitsHeader'
        },
        messagesSave: {
            type: String,
            default: undefined,
            kComposite: 'messages.save'
        },
        messagesViewsDay: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.day'
        },
        messagesViewsEnd: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.end'
        },
        messagesViewsMonth: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.month'
        },
        messagesViewsStart: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.start'
        },
        messagesViewsWeek: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.week'
        },
        messagesViewsYear: {
            type: String,
            default: undefined,
            kComposite: 'messages.views.year'
        }
    }
};